import { CustomerGroupFilter } from '../customer';

export enum BeatPlanFrequency {
  Weekly = 'Weekly',
  Bi_Weekly = 'Bi Weekly',
  Monthly = 'Monthly',
}

export enum BeatPlanTypeEnum {
  Routes = 'Routes',
  TeamMembers = 'TeamMembers',
  Customers = 'Customers',
}

export enum BeatPlanStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Archived = 'Archived',
}

export enum BeatPlanScheduleStatus {
  PLANNED = 'PLANNED',
  LEAVE = 'LEAVE',
  WEEK_OFF = 'WEEK OFF',
  HOLIDAY = 'HOLIDAY',
}

export enum BeatPlanDayName {
  Monday = 'Monday',
  TuesDay = 'TuesDay',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
}

export enum BeatPlanType {
  Scheduled = 'Scheduled',
  Leave = 'Leave',
  Holiday = 'Holiday',
  Week_Off = 'Week Off',
}

export type CustomerGroupType =
  | 'ROUTE'
  | 'SEGMENT'
  | 'DYNAMIC_SEGMENT'
  | 'CUSTOMER_LIFE_CYCLE';

export interface FieldOpsCustomerListRequest {
  sellerWorkspaceId: string;
  teamMemberId: string;
  searchKey?: string;
  pageNo?: number;
  pageSize?: number;
}

interface PhysicalAddress {
  address1: string;
  address2?: string;
}

export interface FieldOpsCustomerListResponse {
  data: FieldOpsCustomerListData[];
  pagination: FieldOpsCustomerListPagination;
}

interface FieldOpsCustomerListPagination {
  currentPage: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startIndex: number;
  endIndex: number;
  startRecord: number;
  endRecord: number;
}

export interface FieldOpsCustomerListData {
  id: string;
  name: string;
  isActive: boolean;
  profile: null;
  phone: string;
  physicalAddress: PhysicalAddress;
  latestOrderDate: null;
  companyName: string;
  beatPlanId: string;
  beatPlanScheduleRouteId: string;
  beatPlanScheduleCustomerId: string;
  activity?: ThreadListChannel;
  visitId?: string | null;
  visitStatus?: string | null;
  visits?: Visit[];
  cfaDivisionCustomer: CfaDivisionCustomer[];
  conversation?: Conversation;
  activeLifeCycleGroups: ActiveLifeCycleGroup[];
}

interface Visit {
  checkInTime: string | null;
  checkOutTime: string | null;
  id: string | null;
  status: 'CO' | 'CI' | null;
}

interface CfaDivisionCustomer {
  id: string;
  salesOrg?: string | null;
  fulfillmentLocationCode: string;
  supplierName: string;
}

interface Conversation {
  conversationId: string;
  tags: string[];
  summary?: string;
  latestMessage: string;
}

interface ActiveLifeCycleGroup {
  id: string;
  name: string;
  customerGroupType: string;
  emojiId: string;
  isAutomatic?: boolean;
}

export interface FetchCustomerProfileRequest {
  customerId: string;
  sellerWorkspaceId: string;
  params: {
    pageNo?: number;
    pageSize?: number;
    inviteIds: string[];
  };
}

export interface FetchCustomerProfileResponse {
  data: {
    customerId: string;
    customerName: string;
    physicalAddress: {
      address1: string;
      address2: string;
    };
    phone: string;
    latestInvoice: {
      invoiceNumber: string;
      totalValue: number;
      invoiceDate: string;
      invoiceId?: string;
    };
    latestPayment: {
      createdBy?: string;
      paymentCode: string;
      totalValue: number;
      paymentDate: string;
      paymentId?: string;
    };
    latestOrder: {
      createdBy?: string;
      orderDate: string;
      refOrderNumber: string;
      totalValue: number;
      pofileid?: string;
    };
    creditLimit: string;
    outstandingAmount: number;
    segmentName: string;
    latestCheckInDate: string;
    salesTeamMemberName: string;
  }[];
  endRecord: number;
  last_updatedAt: string;
  startRecord: number;
  statusCode: number;
  totalRecords: number;
}

export interface ThreadListChannel {
  conversationTags?: string[];
  latestMessageTimeToken?: string;
  name: string;
  latestMessage?: string;
  id: string;
  customer?: ThreadListCustomer;
  visitedAt?: string;
  tags?: ThreadListTags[];
  optedOut?: boolean;
  summary?: string;
}

export type ThreadTagTypes =
  | 'campaign'
  | 'order'
  | 'invoice'
  | 'payment'
  | 'priceList'
  | 'dispatch';

export interface ThreadListTags {
  type: ThreadTagTypes;
  value: string;
}

interface ThreadListCustomer {
  name: string;
  distributorCode: string;
  id: string;
  isActive: number;
}

export interface GetScheduleRequest {
  sellerWorkspaceId: string;
  teamMemberId: string;
  searchKey?: string;
  pageNo?: number;
  pageSize?: number;
}

export interface RouteScheduleResponse {
  id: string;
  createdDate: string;
  updatedDate: string;
  beatPlanId: string;
  scheduleDate: string;
  dayName: string;
  routeId: string;
  teamMemberId: string;
  scheduleStatus: string;
  scheduleTime: null;
  visitOrder: number;
  notes: null;
  route: Route;
}

interface Route {
  id: string;
  createdDate: string;
  updatedDate: string;
  name: string;
  description: string;
  workspaceId: string;
  customerGroupType: string;
  parentId: string;
  emojiId: string;
  customerCount?: number;
}

export interface GetGroupMembersRequest {
  groupId: string;
  sellerWorkspaceId: string;
  pageNo: number;
  pageSize: number;
  searchKey?: string;
  cfaIds?: string[];
  divisionIds?: string[];
  isConversation?: boolean;
  status?: string;
  tag?: string;
  isSendVisits?: boolean;
  beatPlanId?: string;
  isIncludeLifeCycleGroups?: boolean;
}

export interface GetGroupMembersResponse {
  customerGroupMembers: CustomerGroupMember[];
  totalCount: number;
  startRecord: number;
  endRecord: number;
  totalPages: number;
  totalRecords: number;
}

export interface CustomerGroupMember {
  conversations?: MemberConversationInfo;
  id: string;
  name: string;
  companyName: string;
  phone: string;
  address: string;
  customerId: string;
  divisionIds: string[];
  cfaIds: string[];
  visits: Visit[];
  activeLifeCycleGroups: ActiveLifeCycleGroup[];
}

export interface MemberConversationInfo {
  success: boolean;
  data: ConversationInfo[];
  pagination: PaginationMeta;
  message: string;
}

export interface ConversationInfo {
  id: string;
  customerId: string;
  workspaceId: string;
  status: string;
  isAssigned: boolean;
  lastMessage: string;
  summary?: string;
  createdAt: string;
  lastMessageAt: string;
  metadata?: Metadata;
}

export interface Metadata {
  tags: string[];
  summary?: string;
  assignedTo?: {
    teamMemberName: string;
    teamMemberId: string;
    role: string;
  }[];
  status?: string;
}

export interface PaginationMeta {
  hasMore: boolean;
  nextCursor?: {
    lastMessageAt: string;
    startKey: string;
  };
  total: number;
}

export interface GetTripSummaryRequest {
  params: {
    sellerWorkspaceId: string;
    teamMemberId: string;
    status: 'PROCESSED' | 'PENDING';
    date: string;
  };
}

export interface GetTripSummaryResponse {
  customerId: string;
  customerName: string;
  groupedMessages: GroupedMessage[];
}

export interface GroupedMessage {
  id: string;
  entityType: GroupedMessageEntityType;
  entityId: string;
  totalLineItems: number;
  totalWithTax: number;
  originalMessages: OriginalMessage[];
}

export interface OriginalMessage {
  content: string;
  timestamp: string;
}

export type GroupedMessageEntityType =
  | 'payment'
  | 'issue'
  | 'order'
  | 'internal_note';

export interface AddGroupMembersRequest {
  sellerWorkspaceId: string;
  groupId: string;
  body: {
    customerIds: string[];
  };
}

export interface AddGroupMembersResponse {
  customerGroup: CustomerGroupResponse;
  errorCustomers: any[];
}

export interface CustomerGroupResponse {
  id: string;
  createdDate: string;
  updatedDate: string;
  name: string;
  description: string;
  workspaceId: string;
  customerGroupType: string;
  parentId: string;
  CustomerGroupMembers: {
    id: string;
    createdDate: string;
    updatedDate: string;
    customerId: string;
    customerGroupId: string;
  }[];
}

export interface BeatPlanSchedule {
  scheduleDate?: string;
  scheduleStatus?: BeatPlanScheduleStatus;
  dayName?: BeatPlanDayName;
  teamMemberId: string;
  customerId?: string | null;
  routeId?: string | null;
  visitOrder?: number;
}

export interface BeatPlanScheduleCustomer {
  beatPlanId: string;
  scheduleDate: string;
  dayName: BeatPlanDayName;
  teamMemberId: string;
  scheduleStatus: BeatPlanScheduleStatus;
  visitOrder: number;
  notes?: string;
  customerId?: string;
  routeId?: string;
  id: string;
  createdDate?: string;
  updatedDate?: string;
}

export interface NonPeriodicBeatPlanInfoResponse {
  id: string;
  createdDate: string;
  updatedDate: string;
  planName: string;
  workspaceId: string;
  startDate: any;
  endDate: any;
  frequency: any;
  beatType: string;
  status: string;
  isPeriodic: boolean;
  beatPlanScheduleRoutes?: BeatPlanScheduleCustomer[];
  beatPlanScheduleCustomers?: BeatPlanScheduleCustomer[];
}

export interface UpdateBeatPlanSchedules {
  beatPlanId: string;
  scheduleDate: string | null;
  dayName: string | null;
  teamMemberId: string;
  scheduleStatus?: string | null;
  visitOrder: number;
  notes?: any;
  routeId?: string | null;
  customerId?: string | null;
  id?: string;
}

export interface UpdateBeatPlanRequest {
  sellerWorkspaceId: string;
  beatPlanId: string;
  body: {
    beatPlanSchedules: UpdateBeatPlanSchedules[];
  };
}

export interface UpdateBeatPlanResponse {
  planName: string;
  workspaceId: string;
  startDate: string;
  endDate: string;
  frequency: BeatPlanFrequency;
  beatType: BeatPlanType;
  status: BeatPlanStatus;
  id: string;
  createdDate: string;
  updatedDate: string;
  beatPlanScheduleRoutes?: BeatPlanScheduleCustomer[];
  beatPlanScheduleCustomers?: BeatPlanScheduleCustomer[];
}

export interface GetAllGroupsRequest {
  sellerWorkspaceId: string;
  customerGroupTypes: CustomerGroupType[];
  searchKey?: string;
  pageSize?: number;
  pageNo?: number;
  startDate?: string;
  endDate?: string;
}

export interface GetAllGroupsResponse {
  groupType: CustomerGroupType;
  folders: CustomerGroupFilter[];
  rootCustomerGroups: CustomerGroupListItem[];
  supportsHierarchy: boolean;
  totalCount: number;
  startRecord: number;
  endRecord: number;
  totalPages: number;
}

export interface CustomerGroupListItem {
  id: string;
  createdDate: string;
  updatedDate: string;
  name: string;
  description: string;
  workspaceId: string;
  customerGroupType: string;
  parentId: null;
  emojiId: string;
  isActive: boolean;
  isExistingChannel?: boolean;
  isAutomatic: boolean;
  isDefaultLifeCycle: boolean;
  customerCount: number;
  segmentLastRefreshedAt: string;
  customerGroupRules?: CustomerGroupRules[];
}

export interface CustomerGroupRules {
  id: string;
  createdDate: string;
  updatedDate: string;
  segmentId: string;
  groupId: string;
  metricPeriod: string;
  operator: string;
  metricValue: string;
  sequence: number;
  groupOperator: string;
  metricId: string;
  query: string;
}

export interface CreateBeatPlanByCustomerRequest {
  body: {
    planName: string;
    startDate: string | null;
    endDate: string | null;
    isPeriodic: boolean;
    frequency: BeatPlanFrequency | null;
    beatType: BeatPlanTypeEnum;
    status: BeatPlanStatus;
    beatPlanSchedules: BeatPlanSchedule[];
  };
  sellerWorkspaceId: string;
}

export interface CreateBeatPlanByCustomerResponse {
  planName: string;
  workspaceId: string;
  startDate: string;
  endDate: string;
  frequency: BeatPlanFrequency;
  beatType: BeatPlanType;
  status: BeatPlanStatus;
  id: string;
  createdDate: string;
  updatedDate: string;
  beatPlanScheduleCustomers: BeatPlanScheduleCustomer[];
}

interface CustomerMetrics {
  routes?: string[];
  segments?: string[];
  outstandingamount?: string;
  lastinvoicedate?: string;
  conversation?: Conversation;
}

export type FieldOpsCustomerWithMetrics = FieldOpsCustomerListData &
  CustomerMetrics;

export type GroupCustomerWithMetrics = CustomerGroupMember & CustomerMetrics;
